'use client';

import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

export function ScrollToUp() {
  const [isVisible, setIsVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const updateScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      const scrolled = (scrollTop / docHeight) * 100;
      setProgress(scrolled);
      setIsVisible(scrollTop > 100);
    };

    window.addEventListener('scroll', updateScroll);
    return () => window.removeEventListener('scroll', updateScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const circleRadius = 24;
  const circumference = 2 * Math.PI * circleRadius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <>
      {/* WhatsApp Button - Always visible */}


      {/* Scroll To Top Button */}
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed scroll-arrow z-50 w-12 h-12 bg-[#003087] hover:bg-[#002a6e] text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all no-print cursor-pointer"
          aria-label="Scroll to top"
        >
          {/* Circular Progress */}
          <svg
            className="absolute inset-0 w-full h-full"
            viewBox="0 0 60 60"
          >
            <circle
              cx="30"
              cy="30"
              r={circleRadius}
              stroke="rgba(255,255,255,0.3)"
              strokeWidth="4"
              fill="none"
            />
            <circle
              cx="30"
              cy="30"
              r={circleRadius}
              stroke="#ffff"
              strokeWidth="4"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
              className="transition-[stroke-dashoffset] duration-150"
            />
          </svg>

          <ArrowUp className="relative w-6 h-6 z-10 hover:-translate-y-0.5 transition-transform text-[#ffff]" style={{
            color:'#fff'
          }}/>
        </button>
      )}
    </>
  );
}
